'use client';

import Link from 'next/link';
import MarketingHeader from '@/components/MarketingHeader';
import { getBrandHomeUrl } from '@/lib/creatorPlatformUrls';
import MarketingFooter from '@/components/MarketingFooter';

export default function AboutPage() {
  return (
    <div className="home-page">
      <MarketingHeader />

      <main className="about-main about-letter">
        <h1 className="home-about-title">给独立创作者的一封信</h1>
        <p className="about-letter-byline">—— 基音 Fundamuse</p>

        <p className="about-letter-tagline"><strong>让每一份才华，都被认真对待。</strong></p>
        <p className="about-letter-tagline-en"><em>Fund a muse, find the future.</em></p>

        <hr className="about-divider" />

        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">如果你正在读到这段文字，</p>
          <p className="home-about-text about-letter-line">也许你正在创作一首歌、一张专辑；</p>
          <p className="home-about-text about-letter-line">也许你已经发布过作品，却并不清楚它真正去了哪里、产生了什么价值；</p>
          <p className="home-about-text about-letter-line">也许你知道自己正在做一件长期的事，却始终缺少一个<strong>真正站在你这一边的系统与支持</strong>。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">我们写下这封信，只想先说清楚一件事：</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced"><strong>基音，并不是只为少数幸运者而生的。</strong></p>
          <p className="home-about-text about-letter-line">它是为那些认真创作、却长期被忽视的创作者而存在。</p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">我们看到的，不只是作品，还有创作者本身</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">在今天的音乐产业中，</p>
          <p className="home-about-text about-letter-line">注意力、资源与机会高度集中在少数头部艺人和大型机构之中。</p>
          <p className="home-about-text about-letter-line">而数量庞大、才华横溢的独立创作者，</p>
          <p className="home-about-text about-letter-line">往往既不在传统经纪体系的服务范围内，</p>
          <p className="home-about-text about-letter-line">也很难获得持续、专业、可积累的支持。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">问题并不在于创作本身。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">真正消耗创作者精力的，</p>
          <p className="home-about-text about-letter-line">是发行、版权、收益、数据、规则与现实世界的复杂性——</p>
          <p className="home-about-text about-letter-line">这些分散而琐碎的事务，</p>
          <p className="home-about-text about-letter-line">让许多优秀作品只能被一次性消耗，</p>
          <p className="home-about-text about-letter-line">却难以沉淀为<strong>长期的价值与回报</strong>。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">基音，正是从这个现实出发而诞生的。</p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">基音在做的，是把复杂交还给系统，把创作留给创作者</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">基音（Fundamuse）是一个面向音乐创作者的一站式支持平台。</p>
          <p className="home-about-text about-letter-line">我们通过系统化的发行、版权管理、收益结算与数据分析能力，并结合人工智能与技术驱动的基础设施，帮助创作者从「发布作品」，走向<strong>建立长期可积累的作品资产与收入结构</strong>。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">我们不只是让作品被发出来，而是帮助创作者清楚地知道：</p>
        </div>
        <ul className="about-belief-list">
          <li>作品属于谁</li>
          <li>收益从哪里来</li>
          <li>数据意味着什么</li>
          <li>价值如何被持续放大</li>
        </ul>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line about-letter-line--spaced">你只需要专注于创作本身，其余的规则、流程、结算、数据与复杂事务，<strong>交给基音。</strong></p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">我们的使命</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">让作品创造更高的艺术价值与商业价值。</p>
          <p className="home-about-text about-letter-line">这不是一句口号，而是一种长期选择。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced"><strong>艺术价值</strong>，意味着作品本身。</p>
          <p className="home-about-text about-letter-line">作品能够被尊重、被正确呈现、被耐心对待，</p>
          <p className="home-about-text about-letter-line">创作者可以自由表达审美、情绪与价值观，</p>
          <p className="home-about-text about-letter-line">而不是被快速消费，不被短期流量或算法偏好所裹挟。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced"><strong>商业价值</strong>，意味着作品背后。</p>
          <p className="home-about-text about-letter-line">通过更多渠道、更细分的市场、更适合的受众，</p>
          <p className="home-about-text about-letter-line">作品能够被更好地变现，创造真实、可持续的收益，</p>
          <p className="home-about-text about-letter-line">让创作者不再只能「为爱发电」，</p>
          <p className="home-about-text about-letter-line">而是能够在现实中，持续投入创作本身。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">基音相信，这两者并不冲突。</p>
          <p className="home-about-text about-letter-line"><strong>真正可持续的创作，一定同时建立在 艺术自由 + 商业理性 的长期价值之上。</strong></p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">我们不是经纪公司，也不是流量承诺方</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">我们不承诺「爆款」，</p>
          <p className="home-about-text about-letter-line">不以一次曝光或短期成绩作为唯一目标，</p>
          <p className="home-about-text about-letter-line">也不通过复杂条款提前绑定创作者的未来。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">基音真正关心的是：</p>
          <p className="home-about-text about-letter-line">在清晰、透明、可持续的规则下，创作者是否能够——</p>
        </div>
        <ul className="about-belief-list">
          <li>一步一步积累作品</li>
          <li>持续理解和放大自身价值</li>
          <li>获得稳定、可预期的长期收益</li>
        </ul>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line about-letter-line--spaced">在这里，创作者不需要先成为「头部」，也能获得经纪级别的系统支持与长期陪伴。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">成长不是被催促出来的，而是被耐心构建出来的。</p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">Fund a muse, find the future</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">Fundamuse 这个名字，来自两个同样重要的词源。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced"><strong>Fundamental</strong>，代表基础、源头、底层结构。</p>
          <p className="home-about-text about-letter-line">在创作世界里，真正的基础不是平台或流量，</p>
          <p className="home-about-text about-letter-line">而是<strong>创作者本身，以及作品所承载的版权与价值体系</strong>。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced"><strong>Muse</strong>，是灵感，是音乐，是创作，是一切创意的起点。</p>
          <p className="home-about-text about-letter-line">每一个被认真对待的创作瞬间，都可能孕育出更长远的未来。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">Fundamuse 想做的，正是为这些「基础中的基础」建立系统性的支持</p>
          <p className="home-about-text about-letter-line">——不仅是由我们支持，也帮助作品被更多人理解、欣赏与投资。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced"><strong>当才华被认可，当作品被认真对待，未来，才会被真正创造出来。</strong></p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">我们希望成为那个——</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">在你专注创作时，<strong>默默替你把复杂事务处理好的人。</strong></p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">在传统体系中，经纪能力往往只属于少数人。</p>
          <p className="home-about-text about-letter-line">而基音希望通过系统、服务与技术，让每一位独立创作者，都能拥有属于自己的<strong>「经纪级支持」。</strong></p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">你只需要把音乐与作品做到最好，其余的现实问题与商业世界，交给我们。</p>
        </div>

        <hr className="about-divider" />

        <h2 className="about-section-title">关于基音</h2>
        <div className="about-letter-block">
          <p className="home-about-text about-letter-line">基音（Fundamuse）是拉凡达（上海）科技有限责任公司旗下的创作者支持品牌。</p>
          <p className="home-about-text about-letter-line">我们以技术、人工智能、区块链与系统化能力为基础，构建面向音乐与内容创作领域的长期支持体系，为创作者提供创作、管理与价值实现的专业基础设施。</p>
          <p className="home-about-text about-letter-line about-letter-line--spaced">基音从独立创作者出发，</p>
          <p className="home-about-text about-letter-line">并持续探索让更多人能够以合理、透明的方式参与内容价值创造与支持的可能。</p>
        </div>
        <p className="about-letter-tagline" style={{ marginTop: '1.5rem', marginBottom: '0.25rem' }}><strong>让每一份才华，都被认真对待。</strong></p>
        <p className="about-letter-tagline-en"><em>Fund a muse, find the future.</em></p>

        <p style={{ marginTop: '4rem', fontSize: '0.875rem' }}>
          <Link href={getBrandHomeUrl()} className="link-hover">&lt; 返回首页</Link>
        </p>
      </main>

      <MarketingFooter />
    </div>
  );
}
